if (!customElements.get("product-ingredients")) {
  class ProductIngredients extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const section1 = document.querySelectorAll(".section-ingredients")[0];
      const section2 = document.querySelectorAll(".section-ingredients")[1];

      if (section1 && section2) {
        /* MERGE SECTIONS AND REMOVE DUPLICATES */
        let list = section1.querySelector("ul").innerHTML;
        section2.querySelector("ul").innerHTML += list;

        section1.remove();
      }
    }
  }

  customElements.define("product-ingredients", ProductIngredients);
}
